import { TilsynserklaeringFormValues } from "../../interfaces/tilsynserklaering";

export const TILSYN_FORM_INITIAL_VALUES: TilsynserklaeringFormValues = {
  nuvaerendeForsikringsselskab: undefined,
  navnAndetForsikringsselskab: "",
  nuvaerendeForsikringPolicenr: "",
  forsikringSidstAar: "",
  ejerandeleIAndenVirksomhed: "",
  ejerandeleIAndenVirksomhedUddyb: "",
  tilsynEjerandele: [
    {
      virksomhedensCVR: "",
      virksomhedensNavn: "",
      andel: "",
      "formaal-1": false,
      "formaal-2": false,
      "formaal-3": false,
      "formaal-4": false,
      "formaal-5": false,
      "formaal-6": false,
      "formaal-7": false,
      "formaal-8": false,
      "formaal-9": false,
      "formaal-10": false,
      "formaal-11": false,
      "formaal-12": false,
      "formaal-13": false,
      "formaal-14": false,
      "formaal-15": false,
      "formaal-16": false,
      "formaal-17": false,
    },
  ],
  harDuHaftForbrugersager: "",
  harDuHaftForbrugersagerUddyb: "",
  harDuHaftStraffesager: "",
  harDuHaftStraffesagerUddyb: "",
  harDuHaftHvidvasksager: "",
  harDuHaftHvidvasksagerUddyb: "",
  virksomhedRisikovurderingAdvokatvirksomhed: "",
  advokatvirksomhedPolitikHvidvaskloven: "",
  advokatvirksomhedForretningsgangeHvidvaskloven: "",
  harDuBenyttetTredjemandEllerOutsourcingKundekendskabsprocedurer: "",
  harDuUnderrettetMistankeFinansieringTerrorisme: "",
  harDuUnderrettetMistankeHvidvask: "",
  hvorMangeSagerOmfattetAfHvidvaskloven: "",
  risikovurderingVirksomhedensForretningsmodel: "",
  sagerKlientPolitiskEksponeret: "",
  sagerKompleksEllerUsaedvanlig: "",
  sagerLempedeKundekendskabsprocedurer: "",
  sagerPaalagtFinansielSanktion: "",
  sagerSkaerpedeKundekendskabsprocedurer: "",
  sagerTransaktionHoejrisikotredjelande: "",
  sagerUdenforEU: "",
  virksomhedenForretningsmodelSagsomraaderPaatageSig: "",
  "sagstype-1a": false,
  "sagstype-1b": false,
  "sagstype-2": false,
  "sagstype-3": false,
  "sagstype-4": false,
  "sagstype-5": false,
  "sagstype-6": false,
};
